import React, { Fragment, useCallback, useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { CiWifiOff } from "react-icons/ci"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button } from "components"
import { removeForceOffline, setForceOffline, setInternetStatus } from "@redux"
import { syncOfflineOrders, testReachablity } from "utils"
import classes from "./PvOnlineStatus.module.scss"

const checkInternetTime = 15 * 1000

const retryTime = 2 * 60 * 1000

const PvOnlineStatus = (props) => {
  const { children } = props

  const [t, i18n] = useTranslation()

  const { online, forceOffline } =
    useSelector(state => state.internetStatus)

  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)

  const interval = useRef(null)

  const retryInterval = useRef(null)

  const checkInternetStatus = async () => {
    const result = await testReachablity()

    syncOfflineOrders()

    if (result) return

    dispatch(
      setInternetStatus(false)
    )

    dispatch(
      setForceOffline()
    )
  }

  const addNetworkListener = () => {
    clearInterval(interval.current)

    if (forceOffline) return

    checkInternetStatus()

    interval.current =
      setInterval(checkInternetStatus, checkInternetTime)
  }

  const handleRetry = async () => {
    setLoading(true)

    try {
      const result = await testReachablity()

      if (!result) return setLoading(false)

      clearInterval(retryInterval.current)

      dispatch(
        setInternetStatus(true)
      )

      dispatch(
        removeForceOffline()
      )
    } catch (err) {
      console.log(err)

      toast.error(t("اتصال_برقرار_نشد"))
    }

    setLoading(false)
  }

  const handleOffline =
    useCallback(() => {
      if (forceOffline) return

      dispatch(setInternetStatus(false))

      dispatch(setForceOffline())

      clearInterval(interval.current)
    }, [forceOffline])

  useEffect(() => {
    addNetworkListener()
  }, [forceOffline])

  useEffect(() => {
    window.addEventListener("offline", handleOffline)

    return () => {
      clearInterval(interval.current)

      clearInterval(retryInterval.current)

      window.removeEventListener("offline", handleOffline)
    }
  }, [forceOffline])

  useEffect(() => {
    if (!online && forceOffline) {
      retryInterval.current =
        setInterval(handleRetry, retryTime)
    }
  }, [online, forceOffline])

  const showOfflineBar = forceOffline || !online

  const dir = i18n.dir(i18n.language)

  const isLtr = dir === "ltr"

  return (
    <Fragment>
      {
        showOfflineBar &&
        <div className={classes["bar"]}>
          <CiWifiOff
            size={25}
            color="white"
          />
          <div className={clsx(classes["text"], isLtr && classes["text-ltr"])}>
            {online
              ?
              <span>{t("حالت_آفلاین")}</span>
              :
              <div className={classes["row"]}>
                <span>
                  {t("حالت_آفلاین_اتصال_اینترنت_قطع_شد")}
                </span>
                <Button
                  loading={loading}
                  color="success"
                  onClick={handleRetry}
                  className={clsx(classes["retry"], isLtr && classes["retry-ltr"])}
                >
                  {t("اتصال_مجدد")}
                </Button>
              </div>
            }
          </div>
        </div>
      }

      <div
        className={clsx(
          classes["container"],
          showOfflineBar && classes["container-offline"]
        )}
      >
        {children}
      </div>
    </Fragment>
  )
}

export default PvOnlineStatus